export default {
  "footer": {
    "address": "Address",
    "visit_us": "Come visit us:",
    "contact": "Contact",
    "contact_description": "Learn more, get in touch with us:",
    "support": "Support",
    "email": "Email",
    "phone": "Phone",
    "social_media": "Follow us on social media:",
    "copyright": "All rights reserved.",
    "innovation_city":"(Innovation City)"
  }
}
